:host {
  display: block;
}

.bundle-tag {
  border: solid 1px #6031a6;
  background-color: #6031a6;
  padding: 2px 8px;
  color: white;
  border-radius: 8px 8px 0 0;
  font-weight: bold;
  font-size: 12px;
  width: max-content;
  margin: 20px auto -2px 0;
}

.price-container {
  min-height: 72px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 16px 12px;
  margin: 16px 0;
  border-radius: 8px;
  background-color: #eff0f4;
  color: #2b2e31;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: left;
}

.bundle .price-container {
  background-color: white;
  margin-top: 0;
  border-radius: 0 8px 8px;
  border: solid 1px #6031a6;
  color: #6031a6;
}

.price-value-container {
  font-size: 14px;
  font-weight: normal;
  width: 55px;
  max-width: 55px;
  min-width: 55px;
  display: inline-block;
}

.price-value {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: -3.96px;

  @include agl-ds-screen-size('medium') {
    font-size: 24px;
  }
}

.price-desc {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  font-weight: normal;
  width: 170.5px;
  border-left: solid 1px #c8cbd7;
  padding-left: 12.5px;
  font-size: 14px;

  @include agl-ds-screen-size('medium') {
    font-size: 16px;
    width: 219.5px;
  }
}

.bundle .price-desc {
  border-left-color: #a7a9b3;
}
